import { StepBadge } from './StepBadge';
import type { TroubleshootingBlock } from './troubleshootingBlocks';
import {
  TroubleshootingBox,
  TroubleshootingHeading,
  TroubleshootingItem,
  TroubleshootingItemBody,
  TroubleshootingItemText,
  TroubleshootingItemTitle,
  TroubleshootingList,
} from './TroubleshootingSteps.styles';

export const TroubleshootingSteps = ({ block }: { block: TroubleshootingBlock }) => (
  <TroubleshootingBox>
    <TroubleshootingHeading>{block.heading}</TroubleshootingHeading>
    <TroubleshootingList>
      {block.steps.map((step, index) => (
        <TroubleshootingItem key={step.title}>
          <StepBadge number={index + 1} />
          <TroubleshootingItemBody>
            <TroubleshootingItemTitle>{step.title}</TroubleshootingItemTitle>
            <TroubleshootingItemText>{step.description}</TroubleshootingItemText>
          </TroubleshootingItemBody>
        </TroubleshootingItem>
      ))}
    </TroubleshootingList>
  </TroubleshootingBox>
);
